export default __webpack_public_path__ + "static/media/frog-hanged.6de43ce2.jpeg";